module.exports = __webpack_public_path__ + "img/u-pets.267540df.jpg";